import * as types from './mutation-types'

export default {
  [types.SET_ESTA_CADASTRANDO_CARTAO] (state, estaCadastrandoCartao) {
    state.estaCadastrandoCartao = estaCadastrandoCartao
  },
  [types.SET_FORMA_PAGAMENTO_CLIENTE] (state, estaDefinindoFormaPagamentoCliente) {
    state.formularioFormaDePagamentoCliente = estaDefinindoFormaPagamentoCliente
  }
}
